module.exports = __webpack_public_path__ + "img/testBg.756c7a2f.png";